export enum Dir {
    UP, DOWN, LEFT, RIGHT
}
